import { Hyperlink } from '@strata/react-hyperlink';

const Types = {
    INTERNAL: 'internal',
    PHARMACY: 'pharmacy',
    PATIENT: 'patient',
    PAYER: 'payer',
    PROVIDER: 'provider',
} as const;

const Persona = {
    REFERRAL_OPS: 'referral-ops',
    CSM: 'csm',
    PHARMACY_OPS: 'pharmacy-ops',
    LARGE_PHARMACY_STRATEGIC: 'large-pharmacy-strategic',
    LARGE_PHARMACY_FINANCE: 'large-pharmacy-finance',
    LARGE_PHARMACY_PHARMACIST: 'large-pharmacy-pharmacist',
    SMALL_PHARMACY_OWNER: 'small-pharmacy-owner',
    SMALL_PHARMACY_PHARMACIST: 'small-pharmacy-pharmacist',
} as const;

interface PersonaBoxProps {
    title: string;
    description: string;
    applicationType: (typeof Types)[keyof typeof Types];
    personaType: (typeof Persona)[keyof typeof Persona];
    navUrl: string;
}

export const PersonaBox = ({
    title,
    description,
    applicationType,
    personaType,
    navUrl,
}: PersonaBoxProps) => (
    <div>
        <div className="sds_persona__container padding__around--large">
            <div className={`sds_persona__image sds_persona__image--${personaType}`} />
            <div className="sds_persona__title-and-description">
                <div
                    className={`sds_persona__title sds_persona__title--${applicationType} margin__top--small margin__bottom--small`}
                >
                    {title}
                </div>
                <div className="sds_persona__description">{description}</div>
            </div>
            <div>
                <Hyperlink linkText="View Persona" navUrl={navUrl} openInNewTab />
            </div>
        </div>
    </div>
);

PersonaBox.Types = Types;
PersonaBox.Persona = Persona;
